import type { BatterySungageApplicationReadDto } from "~/api/dto/battery-proposal.dto"

import {
  sungageApplicationOutcome as sharedSungageApplicationOutcome,
  type SungageOutcome,
  type SungageOutcomeTone,
} from "../../ProposalSetup/financing/sungage/sungage-application-copy"

export {
  SUNGAGE_MAX_PAYMENT_CONDITION,
  SUNGAGE_ASSUMED_PAYOFF_NOTE,
  SUNGAGE_ACH_ASSUMED_LABEL,
  SUNGAGE_NEXT_STEP_LABEL,
  SUNGAGE_RESUME_LABEL,
  SUNGAGE_RESUME_BUSY_LABEL,
  SUNGAGE_HOSTED_APPLICATION_TITLE,
  SUNGAGE_HOSTED_URL_UNAVAILABLE,
  SUNGAGE_UNCERTAIN_PROMPT,
  SUNGAGE_TERMS_CHANGED_LABEL,
  SUNGAGE_FINANCE_PLAN_MISMATCH_LABEL,
  SUNGAGE_REVIEW_NEEDED_LABEL,
  SUNGAGE_CREDIT_HEADING,
  SUNGAGE_SUBMITTED_TERMS_HEADING,
  SUNGAGE_APPROVED_TERMS_HEADING,
  SUNGAGE_CHECK_UNAVAILABLE,
  SUNGAGE_REFRESH_FAILED_PROMPT,
  SUNGAGE_ESTIMATE_LABEL,
  SUNGAGE_VERIFIED_APPROVED_LABEL,
  SUNGAGE_PROVIDER,
} from "../../ProposalSetup/financing/sungage/sungage-application-copy"

/** Sungage (Battery Only) Vision finance type. */
export const SUNGAGE_BATTERY_FINANCE_TYPE = `sungage_battery`

export const SUNGAGE_FINANCE_PARTNER_LABEL = `Sungage (Battery Only)`
export const SAVE_SUNGAGE_QUOTE_LABEL = `Save Quote`
export const SAVE_SUNGAGE_QUOTE_BUSY_LABEL = `Saving`
export const SAVED_SUNGAGE_QUOTE_LABEL = `BrightStart Quote saved`
export const SAVED_SUNGAGE_QUOTE_PRICING_OUT_OF_DATE_PROMPT = `Quote saved, but pricing could not be refreshed. Refresh Pricing to update the payment.`
export const SUNGAGE_SAVE_REPRICES_NOTE = `This Loan Product's term and APR change the Battery price. Save Quote refreshes pricing, so the saved payment can differ from this preview.`
export const PREVIEW_SUNGAGE_QUOTE_BUSY_LABEL = `Loading BrightStart quote`
export const PREVIEW_SUNGAGE_QUOTE_ERROR_PROMPT = `Unable to preview this BrightStart quote. Try again.`
export const SAVE_SUNGAGE_QUOTE_ERROR_PROMPT = `Unable to save this BrightStart quote. The saved Quote is unchanged.`
export const SUNGAGE_EMPTY_PROMPT = `No eligible BrightStart Loan Products`
export const SUNGAGE_PREVIEW_REQUIRED_PROMPT = `Preview a BrightStart Loan Product to save a Quote.`
export const SUNGAGE_PRICING_REQUIRED_PROMPT = `Refresh Pricing before choosing a BrightStart Loan Product. Quotes use the current Battery System Pricing.`
export const SUNGAGE_READ_ONLY_PROMPT = `You cannot change the Loan Product for this Battery-Only Proposal.`
export const SUNGAGE_PREVIEW_PILL = `Preview`
export const SUNGAGE_PRICING_SUPERSEDED_PROMPT = `Pricing changed. Preview again before saving.`
export const SUNGAGE_PAYMENT_OUT_OF_DATE_LABEL = `Out of date`
export const SUNGAGE_PAYMENT_UNAVAILABLE_PROMPT = `Sungage BrightStart did not return a monthly payment for this Loan Product.`
export const SUNGAGE_RESERVE_NOW_BUSY_LABEL = `Setting up application`
export const SUNGAGE_HOSTED_APPLICATION_EYEBROW = `Sungage Brightstart (Battery Only)`
export const SUNGAGE_NO_APPLICATION_MESSAGE = `No Sungage Existing Loan Application yet. Use Reserve now on the proposal when a current BrightStart Quote is saved.`
export const SUNGAGE_FINANCING_LOCKED_REASON = `An approved Sungage Loan Application locks financing-affecting edits`

export type { SungageOutcome, SungageOutcomeTone }

type SungageOutcomeInput = Pick<
  BatterySungageApplicationReadDto,
  `creditStatus` | `projectProgress` | `reviewNeeded` | `reviewReasons`
>

/**
 * One reading of the saved Sungage credit status, review flag, and project
 * progress, for a BrightStart loan.
 */
export const sungageApplicationOutcome = (
  application: SungageOutcomeInput,
): SungageOutcome => sharedSungageApplicationOutcome(application, `BrightStart`)
